module.exports = "//public.getcloudapp.com/packs/media/images/markers/m_0-e6b53e5db3f377bea8d23c863f90ff9e.svg";